export default {
  jobTitlesList: []
}
